export default __webpack_public_path__ + "static/media/gallery1.185b6f3b.jpg";